import React from "react";
import { Helmet } from "react-helmet";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import { useTranslation } from "react-i18next";
import "./assets/sass/App.sass";
import Header from "./components/Header/Header";
import Home from "./pages/Homepage/Home";
// import Canvas from "./pages/Canvas/Canvas";
import LoginAnimation from "./pages/LoginAnimation/LoginAnimation";
import InitialExplanation from "./pages/InitialExplanation/InitialExplanation";
import BearExplanation from "./pages/BearExplanation/BearExplanation";
import BearSelection from "./pages/BearSelection/BearSelection";
import MyBear from "./pages/MyBear/MyBear";
import Course from "./pages/Course/Course";
import Lottery from "./pages/Lottery/Lottery";
import ChangeStatus from "./pages/ChangeStatus/ChangeStatus";
import Login from "./pages/Login/Login";

import TSSOGuard from "./guard/TSSOGuard";
import LoginGuard from "./guard/LoginGuard";
import InitGuard from "./guard/InitGuard";
import MainGuard from "./guard/MainGuard";
import PageProvider from "./components/store/page/PageProvider";
import ScrollToTop from "./hooks/ScrollToTop";

function App() {
  const { i18n, t } = useTranslation();
  const location = useLocation();
  const Guard =
    process.env.REACT_APP_GUARD_TYPE === "tssoguard" ? TSSOGuard : LoginGuard;

  const routesList = [
    {
      path: "/",
      component: (
        <MainGuard key="home">
          <Home />
        </MainGuard>
      ),
    },
    {
      path: "/loginAnimation",
      component: (
        <InitGuard key="loginAnimation">
          <LoginAnimation />
        </InitGuard>
      ),
    },
    {
      path: "/initialExplanation",
      component: (
        <InitGuard key="initialExplanation">
          <InitialExplanation />
        </InitGuard>
      ),
    },
    {
      path: "/bearExplanation",
      component: <BearExplanation />,
    },
    {
      path: "/bearSelection",
      component: (
        <InitGuard key="bearExplanation">
          <BearSelection />
        </InitGuard>
      ),
    },
    {
      path: "/myBear",
      component: (
        <MainGuard key="myBear">
          <MyBear />
        </MainGuard>
      ),
    },
    {
      path: "/course",
      component: (
        <MainGuard key="course">
          <Course />
        </MainGuard>
      ),
    },
    {
      path: "/lottery",
      component: (
        <MainGuard key="lottery">
          <Lottery />
        </MainGuard>
      ),
    },
    // { path: "/canvas", component: <Canvas /> },
    { path: "/changeStatus", component: <ChangeStatus /> },
    {
      path: "*",
      component: <Navigate to="/" replace />,
    },
  ];

  return (
    // 根據不同語系加入不同class
    <div className={`App ${i18n.language}`}>
      <Helmet>
        <title>{t("meta.title")}</title>
        <meta name="title" content={t("meta.title")} />
        <meta name="description" content={t("meta.description")} />
      </Helmet>
      {/* <div className="App"> */}
      <PageProvider>
        {location.pathname === "/login" ? (
          <Routes>
            <Route path="/login" element={<Login />}></Route>
          </Routes>
        ) : (
          <Guard>
            <Header />
            <TransitionGroup>
              <CSSTransition
                key={location.pathname} // 確保 key 唯一
                timeout={{ enter: 1000, exit: 1000 }}
                classNames={{
                  enter: "mask-enter",
                  enterActive: "mask-enter-active",
                  exit: "mask-exit",
                  exitActive: "mask-exit-active",
                }}
                onEnter={() => console.log("Enter start")}
                onEntered={() => console.log("Enter end")}
                onExit={() => console.log("Exit start")}
                onExited={() => console.log("Exit end")}
              >
                <div className="mask">
                  <ScrollToTop />
                  <Routes>
                    {routesList.map((route, index) => (
                      <Route
                        key={route.path + index} // 使用 route.path 作為前綴
                        path={route.path}
                        element={route.component}
                      />
                    ))}
                  </Routes>
                </div>
              </CSSTransition>
            </TransitionGroup>
          </Guard>
        )}
      </PageProvider>
    </div>
  );
}

export default App;
